(function () {
  function pad(n){ return String(n).padStart(2, "0"); }

  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg || "";
    el.style.display = msg ? "block" : "none";
  }

  // ---------------------------
  // PARTIES (Tue–Sun, 10:00–11:30, 13:00–14:30 | 4–12 guests)
  // ---------------------------
  function initPartyBooking() {
    var root = document.querySelector("[data-zc-party-booking]");
    if (!root) return;

    var dateEl = document.getElementById("ZCPartyDate");
    var timeEl = document.getElementById("ZCPartyTime");
    var errEl  = root.querySelector("[data-zc-party-error]");
    var qtySlot = root.querySelector("[data-zc-party-quantity-slot]");
    if (!dateEl || !timeEl) return;

    function showPartyError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || "";
      errEl.style.display = msg ? "block" : "none";
    }

    // Move Debut quantity into our "Guests" slot and enforce min/max
    var form = root.closest("form");
    if (form && qtySlot) {
      var qtyBlock = form.querySelector(".product-form__item--quantity");
      if (qtyBlock && !qtySlot.contains(qtyBlock)) {
        qtySlot.appendChild(qtyBlock);

        var lbl = qtyBlock.querySelector("label");
        if (lbl) lbl.textContent = "Number of guests";

        var inp = qtyBlock.querySelector("input[type='number']");
        if (inp) {
          inp.min = "4";
          inp.max = "12";
          inp.step = "1";
          inp.value = inp.value && Number(inp.value) >= 4 ? inp.value : "4";
          inp.addEventListener("focus", function(){ showPartyError(""); });
        }
      }
    }

    // Allowed days: Tue–Sun (0=Sun … 6=Sat) => block Monday only
    var ALLOWED_WEEKDAYS = [0, 2, 3, 4, 5, 6];

    function clearTimes(msg){
      timeEl.innerHTML = "";
      var opt = document.createElement("option");
      opt.value = "";
      opt.textContent = msg || "Select a time";
      timeEl.appendChild(opt);
    }

    function populateTimes(){
      clearTimes("Select a time");

      var slots = [
        { value: "10:00 - 11:30", label: "10:00 - 11:30" },
        { value: "13:00 - 14:30", label: "13:00 - 14:30" }
      ];

      slots.forEach(function(s){
        var opt = document.createElement("option");
        opt.value = s.value;
        opt.textContent = s.label;
        timeEl.appendChild(opt);
      });
    }

    clearTimes("Select a date first");

    // Flatpickr calendar
    if (window.flatpickr) {
      window.flatpickr(dateEl, {
        dateFormat: "Y-m-d",
        minDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // tomorrow
        disableMobile: true,
        disable: [
          function(d) {
            return ALLOWED_WEEKDAYS.indexOf(d.getDay()) === -1; // blocks Monday
          }
        ],
        onChange: function(selectedDates) {
          if (!selectedDates || !selectedDates.length) {
            clearTimes("Select a date first");
            return;
          }
          showPartyError("");
          populateTimes();
        }
      });
    } else {
      // fallback (if flatpickr fails)
      var now = new Date();
      now.setDate(now.getDate() + 1);
      var p = function(n){ return String(n).padStart(2, "0"); };
      dateEl.min = now.getFullYear() + "-" + p(now.getMonth()+1) + "-" + p(now.getDate());

      dateEl.addEventListener("change", function(){
        if (dateEl.value) populateTimes();
      });
    }

    // Prevent add-to-cart unless date + time chosen
    var form2 = dateEl.closest("form");
    if (form2) {
      form2.addEventListener("submit", function(e){
        if (!dateEl.value) { showPartyError("Please choose a party date."); e.preventDefault(); return; }
        if (!timeEl.value) { showPartyError("Please choose a party time."); e.preventDefault(); return; }

        var qtyInput = form2.querySelector(".product-form__item--quantity input[type='number']");
        if (qtyInput) {
          var g = Number(qtyInput.value || 0);
          if (g < 4 || g > 12) {
            showPartyError("Guests must be between 4 and 12.");
            e.preventDefault();
            return;
          }
        }

        showPartyError("");
      });
    }
  }

  // ---------------------------
  // WORKSHOP product page: pick a session (sets real variant id + max seats UX)
  // ---------------------------
  function initWorkshopSessionPicker() {
    var root = document.querySelector("[data-zc-workshop-booking]");
    if (!root) return;

    var productId = root.getAttribute("data-product-id");
    var selectEl = document.getElementById("ZCWorkshopSession");
    var dateHidden = root.querySelector("[data-zc-workshop-date]");
    var timeHidden = root.querySelector("[data-zc-workshop-time]");
    var errEl = root.querySelector("[data-zc-workshop-error]");
    var qtySlot = root.querySelector("[data-zc-quantity-slot]");
    if (!productId || !selectEl) return;

    var form = root.closest("form");
    if (!form) return;

    // Store default variant id so we can reset if user clears selection
    var defaultVariantId = "";
    var idField = form.querySelector('[name="id"]');
    if (idField) defaultVariantId = String(idField.value || "");

    // Track the participants input once moved
    var participantsInput = null;

    // Move quantity block into our slot
    if (qtySlot) {
      var qtyBlock = form.querySelector(".product-form__item--quantity");
      if (qtyBlock && !qtySlot.contains(qtyBlock)) {
        qtySlot.appendChild(qtyBlock);

        var lbl = qtyBlock.querySelector("label");
        if (lbl) lbl.textContent = "Participants";

        participantsInput = qtyBlock.querySelector("input[type='number']");
        if (participantsInput) {
          participantsInput.setAttribute("min", "1");
          participantsInput.setAttribute("step", "1");
          // default hard cap until a session is selected
          participantsInput.setAttribute("max", "20");

          participantsInput.addEventListener("input", function () {
            var v = parseInt(participantsInput.value || "1", 10);
            var mx = parseInt(participantsInput.getAttribute("max") || "20", 10);
            if (isNaN(v) || v < 1) v = 1;
            if (!isNaN(mx) && v > mx) v = mx;
            participantsInput.value = v;
          });
        }
      } else if (qtyBlock) {
        participantsInput = qtyBlock.querySelector("input[type='number']");
      }
    }

    function setVariantId(variantId) {
      if (!variantId) return;
      var f = form.querySelector('[name="id"]');
      if (f) {
        f.value = String(variantId);
        try { f.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}
      }
    }

    function setParticipantsMax(maxSeats) {
      if (!participantsInput) return;

      // Fallback behaviour
      var mx = (typeof maxSeats === "number" && isFinite(maxSeats) && maxSeats > 0) ? maxSeats : 20;

      // Never allow above 20 (your global cap)
      mx = Math.min(mx, 20);

      participantsInput.setAttribute("max", String(mx));

      // Clamp current value if needed
      var current = parseInt(participantsInput.value || "1", 10);
      if (isNaN(current) || current < 1) current = 1;
      if (current > mx) participantsInput.value = String(mx);
    }

    // Load sessions JSON (must include variant_id + available_qty)
    var jsonEl = document.getElementById("ZCWorkshopSessionsJson-" + productId);
    var sessions = [];
    try { sessions = JSON.parse(jsonEl.textContent || "[]"); } catch (e) { sessions = []; }

    var nowMs = Date.now();
    sessions = sessions
      .map(function (s) {
        s.start_ts = Number(s.start_ts);
        s.end_ts = Number(s.end_ts);
        s.variant_id = String(s.variant_id || "");
        s.available_qty = (s.available_qty === null || s.available_qty === undefined) ? null : Number(s.available_qty);
        s._start = new Date(s.start_ts * 1000);
        s._end = new Date(s.end_ts * 1000);
        return s;
      })
      .filter(function (s) {
        return s.variant_id && !isNaN(s._start.getTime()) && (s.start_ts * 1000) >= nowMs;
      })
      .sort(function (a, b) { return a.start_ts - b.start_ts; });

    function hhmm(d) { return pad(d.getHours()) + ":" + pad(d.getMinutes()); }
    function dateNoWeekday(d) {
      var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    // Build dropdown
    selectEl.innerHTML = "";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = sessions.length ? "Select Session" : "No upcoming sessions";
    selectEl.appendChild(ph);

    sessions.forEach(function (s) {
      var dateTxt = dateNoWeekday(s._start);
      var timeTxt = hhmm(s._start) + " - " + hhmm(s._end);
      var label = dateTxt + "  •  " + timeTxt;

      var opt = document.createElement("option");
      opt.value = s.handle;
      opt.textContent = label;
      opt.setAttribute("data-date", dateTxt);
      opt.setAttribute("data-time", timeTxt);
      opt.setAttribute("data-variant-id", s.variant_id);

      // seat availability for UX cap (optional)
      if (typeof s.available_qty === "number" && isFinite(s.available_qty)) {
        opt.setAttribute("data-available-qty", String(s.available_qty));
      }

      selectEl.appendChild(opt);
    });

    function syncSelected() {
      var opt = selectEl.options[selectEl.selectedIndex];

      // No selection → clear properties AND reset variant id, reset max back to 20
      if (!opt || !opt.value) {
        if (dateHidden) dateHidden.value = "";
        if (timeHidden) timeHidden.value = "";
        if (defaultVariantId) setVariantId(defaultVariantId);
        setParticipantsMax(20);
        return;
      }

      var dateTxt = opt.getAttribute("data-date") || "";
      var timeTxt = opt.getAttribute("data-time") || "";
      var variantId = opt.getAttribute("data-variant-id") || "";

      if (dateHidden) dateHidden.value = dateTxt;
      if (timeHidden) timeHidden.value = timeTxt;

      setVariantId(variantId);

      // Update max seats based on remaining inventory for that variant
      var aq = opt.getAttribute("data-available-qty");
      var availableSeats = aq !== null ? Number(aq) : null;
      setParticipantsMax(availableSeats);
    }

    // Preselect from calendar (?session=handle)
    try {
      var params = new URLSearchParams(window.location.search);
      var preselect = params.get("session");
      if (preselect) selectEl.value = preselect;
    } catch (e) {}

    syncSelected();

    selectEl.addEventListener("change", function () {
      showError(errEl, "");
      syncSelected();
    });

    // Must choose a session
    form.addEventListener("submit", function (e) {
      if (!selectEl.value) {
        showError(errEl, "Please choose a workshop session.");
        e.preventDefault();
        return;
      }
      syncSelected();
    });
  }

  // ---------------------------
  // WORKSHOP: rewrite Shopify clamp message (workshops only)
  // ---------------------------
  function initWorkshopQtyMessageOverride() {
    var workshopRoot = document.querySelector("[data-zc-workshop-booking]");
    if (!workshopRoot) return;

    var form = workshopRoot.closest("form");
    if (!form) return;

    var errWrap = form.querySelector("[data-error-message-wrapper]");
    var errText = form.querySelector("[data-error-message]");
    if (!errWrap || !errText) return;

    function maybeRewrite() {
      var txt = (errText.textContent || "").trim();
      if (!txt) return;

      var t = txt.toLowerCase();
      var looksLikeAvailability =
        t.indexOf("only") !== -1 &&
        (t.indexOf("added to your cart") !== -1 ||
         t.indexOf("added to your basket") !== -1 ||
         t.indexOf("due to availability") !== -1 ||
         t.indexOf("in your cart") !== -1);

      if (!looksLikeAvailability) return;

      var m = txt.match(/\b(\d+)\b/);
      var n = m ? m[1] : null;

      errText.textContent =
        "Only " + (n || "the available number of") + " places are available and added to your cart. For more, please contact us before booking.";
    }

    var mo = new MutationObserver(function() { maybeRewrite(); });
    mo.observe(errWrap, { attributes: true, childList: true, subtree: true, characterData: true });

    form.addEventListener("submit", function() {
      setTimeout(maybeRewrite, 0);
      setTimeout(maybeRewrite, 50);
      setTimeout(maybeRewrite, 150);
    });
  }

  document.addEventListener("DOMContentLoaded", function(){
    initPartyBooking();
    initWorkshopSessionPicker();
    initWorkshopQtyMessageOverride();
  });
})();